import { AppDispatch } from "@Reducers/index";
import { getBackendUrl } from "@Utils";
import axiosWrapper from "@AxiosWrapper";
import type {
  GetNotificationsRequest,
  GetNotificationsCountRequest,
  NotificationsRequest,
  NotificationsResponse,
  GetNotificationsResponse,
  GetNotificationsCountResponse,
} from "@ServerTypes/notifications/notifications.schema";
import {
  setNotificationsData,
  setUnreadNotificationsCount,
  setShowNotification,
  readNotificationsData,
  unreadNotificationsData,
  setNotificationsStatusesData,
} from "../reducers/notification";

export {
  setNotificationsData,
  setUnreadNotificationsCount,
  setShowNotification,
  readNotificationsData,
  unreadNotificationsData,
  setNotificationsStatusesData,
};

export async function getNotificationsList(skip = 0, take = 20, signal?: AbortSignal) {
  const data: GetNotificationsRequest = {
    value: {
      skip,
      take,
      requiresCounts: true,
      notificationType: ["NOTIFICATION_UNREAD"],
    },
  };

  const response = await axiosWrapper.post<GetNotificationsResponse>(
    `${getBackendUrl()}/notifications/getNotifications`,
    data,
    { signal },
  );
  return response.data;
}

export function getNotificationsCount(filterType: GetNotificationsCountRequest["filter"]) {
  const data: GetNotificationsCountRequest = {
    filter: filterType,
  };
  return async (dispatch: AppDispatch) => {
    try {
      const response = await axiosWrapper.post<GetNotificationsCountResponse>(
        `${getBackendUrl()}/notifications/getNotificationsCount`,
        data,
      );

      if (response.data.status) {
        dispatch(setUnreadNotificationsCount(response.data.data?.count ?? 0));
      }
    } catch (err) {
      console.log(err);
      Promise.reject(err);
    }
  };
}

export async function readNotification(idsArr: NotificationsRequest["ids"]) {
  const data: NotificationsRequest = {
    ids: idsArr,
  };

  try {
    const response = await axiosWrapper.post<NotificationsResponse>(
      `${getBackendUrl()}/notifications/dismissNotification`,
      data,
    );

    return response.data.status;
  } catch (err) {
    console.log(err);
    Promise.reject(err);
  }
}

export async function unreadNotification(idsArr: NotificationsRequest["ids"]) {
  const data: NotificationsRequest = {
    ids: idsArr,
  };

  try {
    const response = await axiosWrapper.post<NotificationsResponse>(
      `${getBackendUrl()}/notifications/unreadNotification`,
      data,
    );

    return response.data.status;
  } catch (err) {
    console.log(err);
    Promise.reject(err);
  }
}
